import {
  LayoutDashboard,
  Users,
  Building2,
  FileText,
  BarChart3,
  Settings,
  Zap,
  Handshake,
  CalendarCheck,
  Sun,
  Wallet,
  MapPin,
  Sparkles,
  Globe,
} from "lucide-react";

/**
 * Flat navigation config — no section labels (matches Rootly clean style).
 * Help lives in the sidebar footer, not here.
 *
 * Each item:
 *   id          – unique key
 *   label       – display text
 *   href        – route path
 *   icon        – lucide-react component
 *   badge       – optional string  "BETA" | "NEW" | any
 *   badgeColor  – "blue" | "gray"
 *   feature     – plan feature key; hidden unless the org's plan/overrides enable it
 *   children    – sub-nav items (same shape, no deep nesting)
 */
export const NAV_CONFIG = [
  {
    id: "dashboard",
    label: "Dashboard",
    href: "/dashboard",
    icon: LayoutDashboard,
  },
  {
    id: "my-day",
    label: "My Day",
    href: "/my-day",
    icon: Sun,
  },
  {
    id: "leads",
    label: "Leads",
    href: "/leads",
    icon: Users,
    requires: { resource: "leads", action: "read" },
  },
  // {
  //   id: "qualification",
  //   label: "Qualified Queue",
  //   href: "/qualification",
  //   icon: Sparkles,
  //   badge: "AI",
  //   badgeColor: "blue",
  //   requires: { resource: "leads", action: "read" },
  //   feature: "qualified_queue",
  // },
  {
    id: "deals",
    label: "Deals",
    href: "/deals",
    icon: Handshake,
    requires: { resource: "deals", action: "read" },
  },
  {
    id: "bookings",
    label: "Bookings",
    href: "/bookings",
    icon: CalendarCheck,
    requires: { resource: "bookings", action: "read" },
  },
  {
    id: "contacts",
    label: "Contacts",
    href: "/contacts",
    icon: Users,
    requires: { resource: "contacts", action: "read" },
  },
  {
    id: "site-visits",
    label: "Site Visits",
    href: "/site-visits",
    icon: MapPin,
    requires: { resource: "site_visits", action: "read" },
  },
  {
    id: "properties",
    label: "Properties",
    href: "/properties",
    icon: Building2,
    // Shown to any account type with listings:read (brokers and developers).
    requires: { resource: "listings", action: "read" },
  },
  {
    id: "website",
    label: "Website",
    href: "/website",
    icon: Globe,
    requires: { resource: "website", action: "manage_content" },
  },
  {
    id: "projects",
    label: "Projects",
    href: "/projects",
    icon: Building2,
    developerOnly: true,
    requires: { resource: "projects", action: "read" },
  },
  {
    id: "collections",
    label: "Collections",
    href: "/collections",
    icon: Wallet,
    developerOnly: true,
    requires: { resource: "bookings", action: "read" },
    feature: "collections",
  },
  {
    id: "documents",
    label: "Documents",
    href: "/documents",
    icon: FileText,
    requires: { resource: "payments", action: "read" },
  },
  {
    id: "reports",
    label: "Reports",
    href: "/reports",
    icon: BarChart3,
    requires: { resource: "reports", action: "read" },
    feature: "reports",
  },
  {
    id: "configurations",
    label: "Configurations",
    href: "/configurations",
    icon: Settings,
  },
];

